import Vue from 'vue'
import App from './app.vue'

document.addEventListener('DOMContentLoaded', () => {
  document.body.appendChild(document.createElement('app_console'))
  const app = new Vue(App).$mount('app_console')
})
